import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Aureis AI platform", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Research and innovation is a key driver for the competitiveness. Aureis targets the innovation of precision offering own AI platform to predict the human, economic, financial, technological, social and environmental impacts of innovative and R&D projects and related public and private investments. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "buttons is-centered pt-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-backward" })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Next", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-forward" })
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Complete your request", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  type: "post",
  class: "button is-success"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-shopping-basket" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Pay for the report", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_request_progress = _resolveComponent("request-progress")!
  const _component_request_step0 = _resolveComponent("request-step0")!
  const _component_request_step1 = _resolveComponent("request-step1")!
  const _component_request_step2 = _resolveComponent("request-step2")!
  const _component_request_step3 = _resolveComponent("request-step3")!
  const _component_request_step4 = _resolveComponent("request-step4")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.stepNext && _ctx.stepNext(...args)), ["prevent"]))
      }, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_request_progress, {
          onNextStep: _ctx.nextStep,
          active: _ctx.step
        }, null, 8, ["onNextStep", "active"]),
        _hoisted_7,
        _hoisted_8,
        _createVNode(_component_request_step0, {
          active: _ctx.isActive(0),
          onNext: _ctx.next,
          sectors: _ctx.loaded.sectors,
          funding: _ctx.loaded.funding
        }, null, 8, ["active", "onNext", "sectors", "funding"]),
        _createVNode(_component_request_step1, {
          active: _ctx.isActive(1),
          onNext: _ctx.next,
          trls: _ctx.loaded.trls
        }, null, 8, ["active", "onNext", "trls"]),
        _createVNode(_component_request_step2, {
          active: _ctx.isActive(2),
          onNext: _ctx.next,
          "exploitation-plan-options": _ctx.loaded.exploitationPlan
        }, null, 8, ["active", "onNext", "exploitation-plan-options"]),
        _createVNode(_component_request_step3, {
          active: _ctx.isActive(3),
          onNext: _ctx.next,
          investments: _ctx.loaded.investments
        }, null, 8, ["active", "onNext", "investments"]),
        _createVNode(_component_request_step4, {
          active: _ctx.isActive(4)
        }, null, 8, ["active"]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.step > 0 && _ctx.step < 4)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.stepBack && _ctx.stepBack(...args)), ["prevent"]))
              }, _hoisted_12))
            : _createCommentVNode("", true),
          (_ctx.step < 3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.stepNext && _ctx.stepNext(...args)), ["prevent"])),
                class: "button is-info"
              }, _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.step === 3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "button is-success is-info",
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.stepNext && _ctx.stepNext(...args)), ["prevent"]))
              }, _hoisted_18))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onsubmit && _ctx.onsubmit(...args)), ["prevent"])),
            method: "POST"
          }, [
            (_ctx.step === 4)
              ? (_openBlock(), _createElementBlock("button", _hoisted_19, _hoisted_22))
              : _createCommentVNode("", true)
          ], 32)
        ])
      ], 32)
    ]),
    _hoisted_23,
    _hoisted_24,
    _hoisted_25
  ]))
}